import { render, staticRenderFns } from "./destineDetail.vue?vue&type=template&id=efe2c7e8&scoped=true&"
import script from "./destineDetail.vue?vue&type=script&lang=js&"
export * from "./destineDetail.vue?vue&type=script&lang=js&"
import style0 from "./destineDetail.vue?vue&type=style&index=0&id=efe2c7e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe2c7e8",
  null
  
)

export default component.exports